import { Vehicle } from '../api';
import { dayOnly } from '../format';

// On a vehicle row: its self-install subscription is about to end, or has ended.
export function SubBadge({ sub }: { sub: NonNullable<Vehicle['subscription']> }) {
  const text = sub.status === 'expiring' ? `Renew by ${dayOnly(sub.paidUntil)}` : `Ended · hidden from ${dayOnly(sub.hiddenFrom)}`;
  return <span className={`subbadge sub-${sub.status}`} title="Your tracking subscription – see My account">{text}</span>;
}
